/**
 * url配置类
 *@author kyy
 *@date 2021/4/12 10:10
 */
export class UrlConfig {
  public static domain = `https://${process.env.VUE_APP_ENVIRONMENT}.huohuaschool.com`;
  // 打开url地址公共前缀
  public static websiteDomain  = `https://${process.env.VUE_APP_ENVIRONMENT === 'dev' ? 'dev-www' :
    process.env.VUE_APP_ENVIRONMENT === 'test' ? 'test-www' : 'www'}.huohuaschool.com`;
  public static websiteBaseurl = `${UrlConfig.domain}/api-website`;
  public static playComponent = `${UrlConfig.websiteDomain}/component/play/`;

  // 保护政策
  public static privacy        = `${UrlConfig.websiteDomain}/protocol/privacy`;
  // 关于我们
  public static about        = `${UrlConfig.websiteDomain}/about`;

  // 开发文档md文件存放路径
  public static markdownPath = `https://huohua-website.huohuaschool.com/${process.env.VUE_APP_ENVIRONMENT === 'prod' ? 'prod' : 'test'}/open/doc`;
  // 开发文档qa问答文件存放路径
  public static qaPath = `https://huohua-website.huohuaschool.com/${process.env.VUE_APP_ENVIRONMENT === 'prod' ? 'prod' : 'test'}/open/qa`;
}
